(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('ImportedFilesService', ImportedFilesService);

  ImportedFilesService.$inject = ['$resource'];

  function ImportedFilesService ($resource) {
    return $resource(apiUrl + '/importedfiles/:id', { id: '@id' }, {
        	loadCampaignTypes: { url: apiUrl + '/importedfiles/load-campaign-types', method: 'GET', params: {}, isArray: true },
        	getCampaignFields: { url: apiUrl + '/importedfiles/get-campaign-fields', method: 'GET', params: {}, isArray: true }
    });
  }
})();
